import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useGetCurrentUserQuery } from '../../redux/apis';
import LoadingSpinner from '../ui/LoadingSpinner';

/**
 * Route component that checks if user has a verified Stripe account
 * before allowing access to protected routes like product upload
 */
const StripeVerifiedRoute = ({ component: Component, ...rest }) => {
  const { data: user, isLoading, error } = useGetCurrentUserQuery();
  
  // Show loading spinner while checking user status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }
  
  // Check if user is logged in and has a verified Stripe account
  const isVerified = user?.stripeAccountDetail?.chargesEnabled === true;
  
  return (
    <Route
      {...rest}
      render={props => 
        isVerified ? (
          <Component {...props} />
        ) : (
          <Redirect 
            to={{
              pathname: '/dashboard/wallet',
              state: { 
                from: props.location,
                message: 'You need to complete Stripe verification before uploading products'
              }
            }}
          />
        )
      }
    />
  );
};

export default StripeVerifiedRoute; 